module.exports = __webpack_public_path__ + "static/img/9.2cba275.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/zh/9.png
// module id = oAJ8
// module chunks = 0